<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.jobs(v-if="$auth.isAuthenticated && currentUser")
    h1.title
      i.icon.fas.fa-file-alt
      span {{ page.title }}

      b-button.position-absolute.ml-2(v-if="currentUser && currentUser.acl && currentUser.acl.jobs && currentUser.acl.jobs.post",style="right:1.5rem",size="sm",variant="primary",@click="handleLink(`/${$route.params.directory}/job/`)",:disabled="!currentUser || !currentUser.acl || !currentUser.acl.jobs || !currentUser.acl.jobs.post")
        i.fas.fa-plus
        span.ml-2 ポジションの追加

    section.body(ref="body")
      .lock(ref="lock",v-if="lock",@click="unlock()")
      b-navbar
        b-navbar-nav
          b-button(size="sm",variant="link",v-if="!toggleSearch",@click="toggleSearch=true")
            i.fas.fa-search
          b-nav-form.search(inline,@submit.prevent)
            b-input-group(size="sm",v-if="toggleSearch")
              b-form-input(size="sm",v-model="filters.keyword",placeholder="名称の一部で検索")
              b-input-group-append
                b-button(size="sm",@click="toggleSearch=false")
                  i.fas.fa-times
            b-input-group.ml-2(size="sm")
              b-form-select(size="sm",v-model="filters.occupation",:options="options.occupation")
            b-input-group.ml-2(size="sm")
              b-form-select(size="sm",v-model="filters.position",:options="options.position")
            b-input-group.ml-2(size="sm")
              b-form-select(size="sm",v-model="filters.employment",:options="options.employment")
            b-input-group.ml-2(size="sm")
              b-form-select(size="sm",v-model="filters.enable",:options="options.enable")

      section.list
        b-table.data(ref="table",responsive,sticky-header,no-local-sorting,:items="data",:fields="fields",:sort-by="sort",:sort-desc="desc",@sort-changed="sortChanged",select-mode="single",selectable,@row-selected="rowSelected")

        b-navbar
          b-navbar-nav
            b-button.mr-2(size="sm",variant="link",@click="loadData")
              i.fas.fa-sync-alt
            b-nav-text.ml-2.text-muted.small {{ (currentPage - 1) * perPage + 1 }} -
              template(v-if="filteredCount === allCount")
                span.ml-1 {{ perPage > allCount ? allCount : perPage }}
                span.ml-2 /
                span.ml-2 {{ allCount }} 件
              template(v-else)
                span.ml-1 {{ perPage > filteredCount ? filteredCount : perPage }}
                span.ml-2 /
                span.ml-2 {{ allCount }} 件中、該当 {{ filteredCount }} 件

          b-nav-form.form-inline.ml-auto.mr-3
            label.small.mr-2 表示件数
            b-form-select(size="sm",v-model="perPage",:options="optionsPerPage")

          b-navbar-nav
            b-pagination.py-0.my-0.ml-auto.mr-2.align-items-center(v-if="filteredCount",v-model="currentPage",:per-page="perPage",:total-rows="filteredCount")
</template>

<script>
import { cloneDeep, debounce } from 'lodash'

import QueryHash from 'query-hash'
import { getData } from '../utils/api'

import { getOccupationTitle, optionsOccupation, getPositionTitle, optionsPosition, getEmploymentTitle, optionsEmployment, getJobEnableTitle, optionsJobEnable } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'jobs',
  title: 'ポジション一覧'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      lock: false,
      page: page,
      collapsed: true,
      currentUser: null,
      showDetail: false,
      useFilter: false,
      prepared: false,
      data: [],
      params: {},
      filters: {
        occupation: null,
        position: null,
        employment: null,
        enable: null
      },
      options: {
        occupation: [],
        position: [],
        employment: [],
        enable: []
      },
      allCount: null,
      filteredCount: null,
      currentPage: null,
      perPage: null,
      sort: 'postedAt',
      desc: true,
      defaultOrder: '-postedAt',
      toggleSearch: false,
      fields: [
        /*
        {
          key: 'selected',
          label: 'selected',
          class: 'checkbox'
        },
        */
        {
          key: 'name',
          label: 'ポジション名',
          sortable: true
        }, {
          key: 'launchDate',
          label: '採用開始日',
          sortable: true,
          formatter: (val, key, datum) => {
            return val ? dayjs(val).format('YYYY/MM/DD(ddd)') : '-'
          }
        }, {
          key: 'dueDate',
          label: '採用期日',
          sortable: true,
          formatter: (val, key, datum) => {
            return val ? dayjs(val).format('YYYY/MM/DD(ddd)') : '-'
          }
        }, {
          key: 'occupation',
          label: '職種',
          sortable: true,
          formatter: (val) => {
            return getOccupationTitle(val)
          }
        }, {
          key: 'position',
          label: '役職',
          sortable: true,
          formatter: (val) => {
            return getPositionTitle(val)
          }
        }, {
          key: 'employment',
          label: '雇用形態',
          sortable: true,
          formatter: (val) => {
            return getEmploymentTitle(val)
          }
        }, {
          key: 'enable',
          label: '応募状態',
          sortable: true,
          formatter: (val) => {
            return getJobEnableTitle(val)
          }
        }, {
          key: 'postedAt',
          label: '作成日時',
          sortable: true,
          formatter: (val, key, datum) => {
            return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : '-'
          }
        }
      ],
      optionsPerPage: [
        { value: 10, text: '10件' },
        { value: 20, text: '20件' },
        { value: 50, text: '50件' },
        { value: 100, text: '100件' }
      ]
    }
  },
  watch: {
    currentPage (newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.loadData()
      }
    },
    perPage (newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.loadData()
      }
    },
    toggleSearch (val) {
      if (!val) {
        this.clearKeyword()
      }
    },
    'filters.keyword': debounce(function () {
      this.loadData()
    }, 1000),
    'filters.occupation' (val) {
      this.loadData()
    },
    'filters.position' (val) {
      this.loadData()
    },
    'filters.employment' (val) {
      this.loadData()
    },
    'filters.enable' (val) {
      this.loadData()
    }
  },
  mounted () {
    this.options.occupation = [{
      value: null,
      text: 'すべての職種'
    }].concat(optionsOccupation())

    this.options.position = [{
      value: null,
      text: 'すべての役職'
    }].concat(optionsPosition())

    this.options.employment = [{
      value: null,
      text: 'すべての雇用形態'
    }].concat(optionsEmployment())

    this.options.enable = [{
      value: null,
      text: 'すべての応募状態'
    }].concat(optionsJobEnable())

    if (this.$route.query.pn) {
      this.currentPage = Number(this.$route.query.pn)
    } else {
      this.currentPage = 1
    }
    if (this.$route.query.pp) {
      this.perPage = Number(this.$route.query.pp)
    } else {
      this.perPage = 10
    }

    if (this.$route.query.order) {
      if (this.$route.query.order.substring(0, 1) === '-') {
        this.desc = true
        this.sort = this.$route.query.order.substring(1)
      } else {
        this.desc = false
        this.sort = this.$route.query.order
      }
    }
  },
  methods: {
    unlock () {
    },
    prepareData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.prepareData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      if (this.$route.query.fk) {
        this.filters.keyword = this.$route.query.fk
        this.toggleSearch = true
      }

      if (this.$route.query.fo) {
        this.filters.occupation = this.$route.query.fo
      }

      if (this.$route.query.fp) {
        this.filters.position = this.$route.query.fp
      }

      if (this.$route.query.fe) {
        this.filters.employment = this.$route.query.fe
      }

      if (this.$route.query.fs === true || this.$route.query.fs === false) {
        this.filters.enable = this.$route.query.fs
      }

      this.prepared = true

      this.loadData()

      this.mask = false
    },
    sortChanged (obj) {
      this.sort = obj.sortBy
      this.desc = obj.sortDesc
      this.loadData()
    },
    orderChanged () {
      this.sortChanged()
    },
    async loadData () {
      this.mask = true

      this.params = {}

      let query = new QueryHash()

      let filters = []
      if (this.filters.keyword) {
        filters.push({ $or: [
          {
            name: `RegExp:('${this.filters.keyword}')`
          }, {
            department: `RegExp:('${this.filters.keyword}')`
          }
        ] })

        this.params.fk = this.filters.keyword
      }
      if (this.filters.occupation) {
        filters.push({ occupation: this.filters.occupation })

        this.params.fo = this.filters.occupation
      }
      if (this.filters.position) {
        filters.push({ position: this.filters.position })

        this.params.fp = this.filters.position
      }
      if (this.filters.employment) {
        filters.push({ employment: this.filters.employment })

        this.params.fe = this.filters.employment
      }
      const filterEnable = String(this.filters.enable).toLowerCase()
      if (filterEnable === 'true' || filterEnable === 'false') {
        filters.push({ enable: filterEnable === 'true' })

        this.params.fs = this.filters.enable
      }

      await getData(`/jobs/count`).then((count) => {
        this.allCount = count
        this.filteredCount = this.allCount
      })

      this.useFilter = false
      if (filters.length > 0) {
        this.useFilter = true

        query.add('filter', JSON.stringify({ $and: filters }))

        await getData(`/jobs/count/?${query.toQueryString()}`).then((count) => {
          this.filteredCount = count
        })
      }

      if (this.currentPage !== 1) {
        this.params.pn = this.currentPage
      }
      if (this.perPage !== 10) {
        this.params.pp = this.perPage
      }

      let offset = (this.currentPage - 1) * this.perPage

      let order = null
      if (this.desc) {
        order = `-${this.sort}`
      } else {
        order = this.sort
      }

      if (order !== this.defaultOrder) {
        this.params.order = order
      }

      query.add('sort', order)
      query.add('limit', this.perPage)
      if (offset !== 0) {
        query.add('skip', offset)
      }

      this.data = []
      await getData(`/jobs?${query.toQueryString()}`).then((data) => {
        if (data && data.length > 0) {
          this.data = cloneDeep(data)
        }
      }).catch((err) => {
        console.log(err)
      })

      this.$router.replace({ name: 'List Jobs', query: this.params }).catch(() => {})

      this.$refs.header.checkCondition()

      this.$refs.table.clearSelected()

      this.mask = false
    },
    clearKeyword () {
      this.filters.keyword = null
    },
    rowSelected (data) {
      if (data && data.length > 0) {
        this.handleLink(`/${this.$route.params.directory}/job/${data[0]._id}`)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.data.table-responsive
  overflow scroll
  min-height calc(100vh - 3.75rem - 5.5rem - 3.375rem - 3.375rem)

  >>> table
    tr.b-table-row-selected
      td
        background-color #fed
</style>
